import type { AxiosInstance, AxiosResponse } from 'axios';

import { HTTP_INTERNAL_SERVER_ERROR } from '@/helpers/httpStatusCodes';
import { useAlertsStore } from '@/stores/alerts/useAlertsStore';

export default (http: AxiosInstance) => {
    const alertsStore = useAlertsStore();
    http.interceptors.response.use(
        (response: AxiosResponse) => {
            if ('bodyAlert' in response.config) {
                const { text, description, visible, timer } = response.config.bodyAlert;

                if (
                    // response.status === HTTP_NO_CONTENT ||
                    visible === 'success'
                    || visible === 'info'
                ) alertsStore.add({
                    title: text ?? 'Done!',
                    description: description ?? 'Successful response from the server.',
                    critical: false,
                    status: response.status,
                    timer
                });
            }
            return response;
        },
        (error) => {
            if (!error.response) {
                error.response = {
                    status: HTTP_INTERNAL_SERVER_ERROR
                };
            }

            if ('bodyAlert' in error.config) {
                const {
                    text,
                    description,
                    fallback,
                    critical,
                    exclude,
                    visible,
                    timer
                } = error.config.bodyAlert;

                let isCritical = critical ?? false;
                let statusText = text ?? error.response?.data?.message;
                let statusDescription
                    = description ?? error.response?.data?.description;

                if (error.response.status === HTTP_INTERNAL_SERVER_ERROR) {
                    isCritical = true;
                    statusText = 'An internal server error occurred!';
                    statusDescription = 'Please try again later...';
                    if (!error.response.data && fallback) {
                        error.response.data = fallback;
                    }
                }

                if (exclude === undefined || !exclude.includes(error.response.status)) {
                    if (visible === 'error' || visible === 'info') {
                        alertsStore.add({
                            title: statusText ?? '',
                            description: statusDescription ?? '',
                            critical: isCritical,
                            status: error.response.status ?? HTTP_INTERNAL_SERVER_ERROR,
                            timer
                        });
                    }

                    const responseData = error.response.data ?? (fallback
                        ? fallback
                        : null);

                    return {
                        status: error.response.status,
                        config: { url: error.config.url },
                        data: responseData
                    };
                }
            }
            return Promise.reject(error);
        }
    );
};
